import React, { useState } from 'react';

// Packages
import { Alert, Button, Flex, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const LoadFileReviewError = (props) => {
	const { error } = props;

	const { t } = useTranslation();

	const [viewErrorDetails, setViewErrorDetails] = useState(false);

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				marginTop: '1.5rem'
			}}
		>
			<Alert
				style={{ width: 1000 }}
				message={
					<Flex justify='space-between'>
						<Typography.Text style={{ fontSize: '16px' }}>
							{error?.info?.name}
						</Typography.Text>
						{error?.data &&
							<Button size='small' danger onClick={() => setViewErrorDetails(!viewErrorDetails)}>
								{t('loadStatus.statusTable.actionButtons.details')}
							</Button>
						}
					</Flex>
				}
				description={
					<Space direction='vertical'>
						<Typography.Text>{error?.info?.description}</Typography.Text>
						{viewErrorDetails &&
							<ul>
								{error?.data?.locations.map((location, index) => (
									<li key={index}>{location}</li>
								))}
							</ul>
						}
					</Space>
				}
				type='error'
				showIcon
			/>
		</div>
	)
}

LoadFileReviewError.propTypes = {
	error: PropTypes.object.isRequired
}

export default LoadFileReviewError;
